module.exports = __webpack_public_path__ + "img/prepaid100-en.74d1a623.svg";